module.exports = __webpack_public_path__ + "img/go-to-liveabc-button-mobile.201c2e2b.png";